export default {
  login: {
    email: {
      placeholder: 'Email',
      submit: 'Continue'
    },
    errors: {
      credentials_invalid: 'Login failed - please verify that your email and password are correct.',
      invitation_not_found: 'Login failed - your invitation was not found.',
      invitation_sso_enabled: 'Login failed - please authenticate with your SSO identity provider.',
      invite_code_expired: 'Login failed - your invitation has expired.',
      invite_code_used: 'Login failed - your invitation was already accepted.',
      lock_out: 'Login failed - you have been locked out for {duration} due to too many failed login attempts.',
      sso_enabled: 'Login failed - please authenticate with your SSO identity provider.'
    },
    general: {
      back: 'Back to email',
      or: 'or',
      register: 'Don\'t have an account? <a href={- url}>Sign Up</a>',
      signupAltText: 'Don\'t have an account?',
      signupTitle: 'Sign Up',
      title: {
        login: 'Log In',
        register: 'Sign Up',
        alt: 'Don\'t have an account?'
      }
    },
    clever: 'Log in with Clever',
    github: 'Log in with GitHub',
    google: 'Log in with Google',
    invite: {
      academy_invite: 'Welcome to Posit Academy!',
      account_invite: 'You have been invited to join an account on Posit by {email}.',
      application_invite: 'An application on shinyapps.io has been shared with you by {email}.',
      space_invite: 'You have been invited to join a space on Posit by {email}.',
      resolution: 'Please log in or sign up to continue.'
    },
    password: {
      placeholder: 'Password',
      submit: 'Log in',
      forgot: 'Forgot your password?'
    },
    log_in_agreement: 'By logging in, you agree to the <a href="https://posit.co/about/posit-service-terms-of-use/" target="_blank" rel="noopener noreferrer">Posit Service Terms of Use</a> and <a href="https://posit.co/about/privacy-policy/" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.',
    sso: {
      details: {
        dedicated: 'Access to Posit is provided via {name}.',
        user: 'Your access to Posit is provided via {name}.',
      },
      change: {
        email: 'Email',
        prompt: 'No longer have access to Posit via {name}? {button}',
        login: 'Log in directly to Posit.',
        message: '<p>No longer have access to Posit via {name}?</p>' +
          '<p>You may log in directly to Posit by changing your login method.</p>' +
          '<p>If you change the way you log in, you will no longer have access to resources owned by {name}.</p>',
        submit: 'Change Login Method'
      },
      unpair: {
        changeLogin: 'Change Login Method',
        details: {
          message: '<p>No longer have access to Posit via {name}?</p>' +
            '<p>You may log in directly to Posit by changing your login method.</p>' +
            '<p>If you change the way you log in, you will no longer have access to resources owned by {name}.</p>'
        },
        sent: {
          title: 'Change Login Method Link Sent',
          message: '<p>We have sent a new change login method link to <strong>{email}</strong>.</p><p>If you don\'t see it shortly, please check your spam folder.</p>'
        },
      },
      not_authorized: '{name} has not authorized you to log in to Posit. If you believe this is an error, please contact an administrator at {name}.',
      submit: 'Log in via {name}'
    },
  } // a namespace is required by i18next
};
